<template>
  <div class="posting" v-bind:class="{ 'posting--new': isNew, 'posting--link': url  }">
    <div class="posting__column">
      <img
        :src="require(`@/assets/${profile}`)"
        alt="Nicola Bolton"
        title="Nicola Bolton <nicolaebolton@gmail.com>"
        class="avatar avatar--small"
        width="50"
        height="50"
      />
    </div>
    <router-link :to="url" class="posting__column posting__link">
      <div class="posting__column posting__content">
        <h3 class="posting__headline">
          {{ heading }}
          <span v-if="sender" class="posting__sender">‹{{ sender }}›</span>
        </h3>
        <p class="posting__byline">
          <span v-if="detail" class="posting__detail">{{ detail }}</span>

          <span v-if="summary" class="posting__summary">&nbsp; - {{ summary }}</span>
        </p>
      </div>
      <div class="posting__column posting__time">{{ date }}</div>
    </router-link>
  </div>
</template>



<script>
export default {
  name: "Email",
  props: [
    "heading",
    "detail",
    "summary",
    "date",
    "url",
    "profile",
    "sender",
    "isNew"
  ]
};
</script>

